export const getFilepath = (
  newFilePath: string,
  shouldRemoveUploadedFile: boolean,
  uploadedFilePath: string | undefined
): string | undefined => {
  if (newFilePath) {
    return newFilePath;
  }

  if (shouldRemoveUploadedFile) {
    return undefined;
  }

  return uploadedFilePath || undefined;
};
